<template>
  <div class="tem-box">
    <div class="box-bg" v-if="proloading">
      <loadtem :progress="progress" :point="point"></loadtem>
    </div>
    <ScaleScreen :width="1920" :height="1080" class="scale-wrap" v-else>
      <div class="back-mask" v-show="showmask"></div>
      <div class="editFrame">
        <div class="box-bg">
          <div class="edit-head">
            <div class="component" v-show="!isPreview">
              <div class="componentFrame">
                <div class="componentMenu" @click="editHeadtitle">
                  <div class="componentIcon">
                    <img src="../../assets/new-edit.png" style="width: 16px" />
                  </div>
                  <div>标题设置</div>
                </div>
              </div>
            </div>
            <component :is="getComp(topactive, 'head')" :title="toptitle" class="head_component" :rolelevel="rolelevel" :isFirst="isFirst">
            </component>
          </div>
          <div class="edit-content">
            <div class="edit-left">
              <div v-for="(item, i) in 3" :key="i">
                <div class="scope-title">
                  <div class="component component1" v-show="!isPreview">
                    <div class="componentFrame">
                      <div class="componentMenu" @click="openScopeTitle(i)">
                        <div class="componentIcon">
                          <img src="../../assets/icon18.png" style="width: 16px" />
                        </div>
                        <div>标题设置</div>
                      </div>
                    </div>
                  </div>
                  <component :is="getComp(scopeactive, 'scopetitle')" :title="scopetitlelist[i]"
                    :isMore="!!scopename[i].ismore" @tomore="tomore(i)"></component>
                </div>
                <div class="scope-content">
                  <div class="component component1" v-show="!isPreview" :style="`${scopename[i].isloading || scopename[i].uploading
                    ? 'opacity: 1;z-index: 402;'
                    : ''
                    }`">
                    <div v-if="scopename[i].isloading || scopename[i].uploading" class="loading-content">
                      <div class="loading-line">
                        <div class="loading-active" :style="{
                          background: scopename[i].isloading
                            ? '#00FF4E'
                            : '#0089FF',
                          width: scopename[i].per + '%',
                        }"></div>
                      </div>
                      {{
                        scopename[i].isloading
                          ? "数据下载中..."
                          : "数据上传中..."
                      }}
                    </div>
                    <div class="componentFrame" v-else>
                      <div class="componentMenu" @click="openScope(i)">
                        <div class="componentIcon">
                          <img src="../../assets/icon18.png" style="width: 16px" />
                        </div>
                        <div>组件更换</div>
                      </div>
                      <div class="componentMenu" @click="opendata(i)">
                        <div class="componentIcon">
                          <img src="../../assets/new-edit.png" style="width: 16px" />
                        </div>
                        <div>
                          {{ scopename[i].jsondata ? "数据设置" : "数据下载" }}
                        </div>
                      </div>
                      <div class="save-video">
                        <el-switch v-model="scopename[i].issave" @change="handlechange($event, i)">
                        </el-switch>
                        {{ scopename[i].issave ? "已保存" : "保存组件" }}
                      </div>
                    </div>
                  </div>
                  <component :ref="`comp${i}`" :is="getComp(scopename[i].compid, 'scope')" :scopedata="scopename[i]"
                    :vdata="scopename[i].vdata" :jsondata="scopename[i].jsondata"></component>
                </div>
              </div>
            </div>
            <div class="edit-center">
              <div class="center-scope">
                <div class="component component1" v-show="!isPreview">
                  <div class="componentFrame">
                    <div class="componentMenu" @click="opendata(6)">
                      <div class="componentIcon">
                        <img src="../../assets/new-edit.png" style="width: 16px" />
                      </div>
                      <div>
                        {{ scopename[6].jsondata ? "数据设置" : "数据下载" }}
                      </div>
                    </div>
                  </div>
                </div>
                <component :ref="`comp6`" :is="getComp(scopename[6].compid, 'scope')" :scopedata="scopename[6]"
                  :vdata="scopename[6].vdata" :jsondata="scopename[6].jsondata" :valuemap="scopename[6].valueMap">
                </component>
              </div>
              <tem5cent :scopedata="scopename[7]" :vdata="scopename[7].vdata" :jsondata="scopename[7].jsondata"
                ref="comp7"></tem5cent>
            </div>
            <div class="edit-right">
              <div v-for="(item, i) in 3" :key="i">
                <div class="scope-title">
                  <div class="component component1" v-show="!isPreview">
                    <div class="componentFrame">
                      <div class="componentMenu" @click="openScopeTitle(i + 3)">
                        <div class="componentIcon">
                          <img src="../../assets/icon18.png" style="width: 16px" />
                        </div>
                        <div>标题设置</div>
                      </div>
                    </div>
                  </div>
                  <component :is="getComp(scopeactive, 'scopetitle')" :title="scopetitlelist[i + 3]"
                    :isMore="scopename[i + 3].ismore" @tomore="tomore(i + 3)">
                  </component>
                </div>
                <div class="scope-content">
                  <div class="component component1" v-show="!isPreview" :style="`${scopename[i + 3].isloading || scopename[i + 3].uploading
                    ? 'opacity: 1;z-index: 402;'
                    : ''
                    }`">
                    <div v-if="
                      scopename[i + 3].isloading || scopename[i + 3].uploading
                    " class="loading-content">
                      <div class="loading-line">
                        <div class="loading-active" :style="{
                          background: scopename[i + 3].isloading
                            ? '#00FF4E'
                            : '#0089FF',
                          width: scopename[i + 3].per + '%',
                        }"></div>
                      </div>
                      {{
                        scopename[i + 3].isloading
                          ? "数据下载中..."
                          : "数据上传中..."
                      }}
                    </div>
                    <div class="componentFrame" v-else>
                      <div class="componentMenu" @click="openScope(i + 3)">
                        <div class="componentIcon">
                          <img src="../../assets/icon18.png" style="width: 16px" />
                        </div>
                        <div>组件更换</div>
                      </div>
                      <div class="componentMenu" @click="opendata(i + 3)">
                        <div class="componentIcon">
                          <img src="../../assets/new-edit.png" style="width: 16px" />
                        </div>
                        <div>
                          {{
                            scopename[i + 3].jsondata ? "数据设置" : "数据下载"
                          }}
                        </div>
                      </div>
                      <div class="save-video">
                        <el-switch v-model="scopename[i + 3].issave" @change="handlechange($event, i + 3)">
                        </el-switch>
                        {{ scopename[i + 3].issave ? "已保存" : "保存组件" }}
                      </div>
                    </div>
                  </div>
                  <component :ref="`comp${i + 3}`" :is="getComp(scopename[i + 3].compid, 'scope')"
                    :scopedata="scopename[i + 3]" :vdata="scopename[i + 3].vdata" :jsondata="scopename[i + 3].jsondata"
                    :valuemap="scopename[i + 3].valueMap">
                  </component>
                </div>
              </div>
            </div>
          </div>
          <component :is="getComp(topactive, 'bottom')"></component>
        </div>
      </div>
      <div class="componentS" :class="{ title: topEditS || topEditScope }"
        v-show="topEditS || topEditScope || editScope || topComp || LblComp">
        <div class="componentTitle">
          <div class="componentTitleName" v-if="topEditS">标题编辑</div>
          <div class="componentTitleName" v-if="topEditScope">
            组件{{ titleindex + 1 }}标题编辑
          </div>
          <div class="componentTitleName" v-if="editScope">
            组件{{ scopeindex + 1 }}替换
          </div>
          <div class="componentTitleName" v-if="topComp">头底套件替换</div>
          <div class="componentTitleName" v-if="LblComp">模版更换</div>
          <div class="componentclose" @click="editclose">
            <img src="../../assets/close.png" style="width: 100%" />
          </div>
        </div>
        <!-- 头部和组件文字编辑 -->
        <div v-if="topEditS || topEditScope" class="componentContents">
          <div class="single">
            <div class="r_input" v-if="topEditS">
              <el-input v-model="formdata.toptitle" type="text" placeholder="显示文字"></el-input>
            </div>
            <div class="r_input" v-else>
              <el-input v-model="formdata.scopetitle" type="text" placeholder="显示文字"></el-input>
            </div>
          </div>
          <div class="single_btn">
            <el-button @click="submit('headedit')" type="primary" v-if="topEditS">确认</el-button>
            <el-button @click="submit('scopeedit', titleindex)" type="primary" v-else>提交</el-button>
            <el-button @click="editclose">取消</el-button>
          </div>
        </div>
        <!-- 更换组件 -->
        <div v-if="editScope || topComp || LblComp">
          <div class="componentClassAll" v-if="editScope">
            <div :class="{
              componentClassMenu: true,
              active: item.id == sortactive,
            }" v-for="(item, i) in sortlist" :key="i" @click="menuclick(item, 1)">
              {{ item.name }}
            </div>
          </div>
          <div class="componentClassAll" v-if="LblComp">
            <div :class="{
              componentClassMenu: true,
              active: item.id == sortactive,
            }" v-for="(item, i) in localsortlist" :key="i" @click="menuclick(item, 1)">
              {{ item.name }}
            </div>
          </div>
          <div class="componentListAll" v-loading="zujianloading">
            <div v-for="(item, index) in Zujianlist" :class="{'active': (item.component_id == scopename[scopeindex].compid), componentList: true}" :key="index" @click="changeComp(item)">
              <div class="componentPic">
                <img :src="headurl + (item.pic_path || item.zujian_img)" :onerror="defaultImg" />
              </div>
              <div class="componentPicName">【组件】{{ item.name }}</div>
            </div>
            <div class="nodata" v-if="!Zujianlist.length">
              <img src="@/assets/nodata.png" alt="" class="nodata-img" />
            </div>
            <div class="page_bottom">
              <el-pagination background layout="prev, pager, next" :total="pagetotal" :page-size="8"
                @current-change="componentPageChange" :current-page="currentPage" :small="true">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div :class="menu" v-show="!isPreview">
        <div class="return" :style="{ transform: low }" @click="routeback">
          <button>
            <img src="../../assets/return.png" style="width: 100%" />
          </button>
        </div>
        <div class="menulist">
          <div class="menuline1"></div>
          <div class="menulogo">
            <img src="../../assets/logo.jpg" style="width: 100%" />
          </div>
          <!-- <div class="menuname">可视化大屏名称</div>
                    <button class="menuediticon">
                        <img src="../../assets/edit.png" style="width: 100%;">
                    </button> -->
          <div class="menuversion">{{ getLevelName() }}</div>
          <div class="menu-pay" @click="openpaylog">{{ getpaytext() }}</div>
          <!-- <div class="modelediticon"><img src="../../assets/icon13.png" style="width: 100%;"></div>
                    <button class="iconname">模板编辑</button> -->
          <!-- <div class="modelicon2"><img src="../../assets/icon11.png" style="width: 100%;"></div>
                    <button class="iconname">模板还原</button> -->
          <!-- <div class="menuline2"></div> -->
          <div class="modelicon2" style="margin-left: auto">
            <img src="../../assets/edit.png" style="width: 100%" />
          </div>
          <button class="iconname" @click="openTitle">模板编辑</button>
          <div class="modelicon2">
            <img src="../../assets/edit.png" style="width: 100%" />
          </div>
          <button class="iconname" @click="opendata(7)">
            {{ scopename[7].jsondata ? "地图数据编辑" : "地图数据下载" }}
          </button>
          <div class="menuline2"></div>
          <div class="modelicon2">
            <img src="../../assets/icon13.png" style="width: 100%" />
          </div>
          <button class="iconname" @click="preview">预览</button>
          <!--  -->
          <!-- <div class="modelicon3"><img src="../../assets/icon14.png" style="width: 100%;"></div>
                    <button class="iconname">分享</button> -->
          <!-- <div class="modelicon3"><img src="../../assets/icon15.png" style="width: 100%;"></div>
                    <button class="iconname">生成可视化源码</button> -->
          <div class="menuline2"></div>
          <div class="modelicon2"><img src="../../assets/icon8.png" style="width: 100%;"></div>
          <button class="iconname" @click="sharepro(tempdata)">分享</button>
          <div class="modelicon2"><img src="../../assets/setvideo.png" style="width: 100%;"></div>
          <button class="iconname" @click="beginvideo">录屏</button>
          <div class="modelicon2">
            <img src="../../assets/screen.png" style="width: 100%" />
          </div>
          <button class="iconname" @click="screen()">全屏</button>
          <div class="modelicon2">
            <img src="../../assets/icon16.png" style="width: 100%" />
          </div>
          <button class="iconname" @click="savepro">保存</button>
          <div class="modelicon2">
            <img src="../../assets/icon17.png" style="width: 100%" />
          </div>
          <button class="iconname" @click="logout" style="margin-right: 32px">
            退出
          </button>
        </div>
      </div>
      <largedialog :dialogVisible="largevisible" @largeclose="largeclose" :vdata="dialogdata"></largedialog>
      <div class="water-mark" v-if="rolelevel < 1"></div>
    </ScaleScreen>
    <div class="luckysheet-contain" v-if="showdataEdit">
      <luckysheet @closeSheet="closeSheet" :vdata="exceltdata" :isexcel="isexcel" :apidata="apidata" :isapi="isApi"
        :selectcope="selectcope" @moredata="moredata" @openpaylog="openpaylog"></luckysheet>
    </div>
    <paylog :payvisible="payvisible" @payclose="payclose"></paylog>
    <sharelog :link="sharelink" :showlink="showshare" @shareclose="shareclose" :proId="tempdata.id" :pwd="pwd"></sharelog>
  </div>
</template>

<script>
import ScaleScreen from "@/components/scale-screen/scale-screen.vue";
import mapbg from "@/components/scope/mapbg.vue";
import screenfull from "screenfull";
import luckysheet from "@/components/luckysheet.vue";
import homebottom from "@/components/scopebottom/homebottom2.vue";
import {
  getprodel,
  getTempdel,
  getTbById,
  getLblById,
  proshare,
  getZjData,
  getTbByIdSh,
  getLblByIdSh,
  getTempdelSh
} from "@/api/new";
import { preloadResources } from "@/utils/loading";
import loadtem from "@/components/porloading.vue";
import largedialog from "@/components/largedialog.vue";
import tem5cent from "@/components/scopecenter/scopecenter2.vue";
// import tem5cent from "@/components/scopecenter/scopecenter3.vue";
import * as method from "./methods.js";
import paylog from "@/components/paylog.vue";
import sharelog from '@/components/sharelog.vue'

export default {
  name: "template5",
  props: {
    temdata: {
      type: Object,
      default: () => { }
    },
    isFirst: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ScaleScreen,
    mapbg,
    luckysheet,
    homebottom,
    loadtem,
    largedialog,
    tem5cent,
    paylog,
    sharelog
  },
  data() {
    return {
      defaultImg: 'this.src = "' + require("../../assets/imgerror.png") + '"', //默认图片的地址
      showdataEdit: false,
      low: "rotateY(0deg)",
      loadedComponents: [],
      topEditS: false,
      topEditScope: false,
      editScope: false,
      topComp: false,
      LblComp: false,
      toptitle: "餐饮业招商加盟大屏",
      formdata: {
        toptitle: "",
        scopetitle: "",
      },
      menu: "editMenu",
      componenthead: [],
      topactive: "headtitle.temhead1",
      componentscopetitle: [],
      scopeactive: "scopetitle.textTitle2",
      titleindex: 0,
      scopeindex: 0,
      compcentertitle: [],
      componentscope: [],
      componentbottom: [],
      scopetitlelist: [
        { title: "组件标题1" },
        { title: "组件标题2" },
        { title: "组件标题3" },
        { title: "组件标题4" },
        { title: "组件标题5" },
        { title: "组件标题6" },
        { title: "组件标题7" },
        { title: "组件标题8" },
      ],
      scopename: [
        { compid: "template.scope1", title: "", vdata: "" },
        { compid: "template.scope2", title: "", vdata: "" },
        { compid: "template.scope3", title: "", vdata: "" },
        { compid: "template.scope4", title: "", vdata: "" },
        { compid: "template.scope5", title: "", vdata: "" },
        { compid: "template.scope6", title: "", vdata: "" },
        { compid: "template.scope1.center", title: "", vdata: "" },
        { compid: "", title: "", vdata: "" },
      ],
      currentPage: 1,
      manuMap: [
        { name: "全部组件", id: 1 },
        { name: "标准组件", id: 2 },
        { name: "1.5倍组件", id: 3 },
        { name: "半高组件", id: 4 },
      ],
      menuActive: 0,
      selectdata: [],
      selectdom: [],
      isexcel: false,
      proid: "",
      sortactive: 0,
      levelactive: 0,
      sortlist: [],
      levellist: [],
      pagetotal: 0,
      headurl: process.env.VUE_APP_BASE_API,
      zujianloading: false,
      tempdata: {},
      activescope: "",
      isPreview: false,
      totalscop: [],
      oldscope: {},
      Zujianlist: [],
      activeid: "",
      bgData: [{ vdata: "", jsondata: "" }],
      maxLength: 300000,
      percent: 0,
      showper: false,
      uppercent: 0,
      showup: false,
      requestList: [],
      upindex: 1,
      getdataList: [],
      getindex: 0,
      curindex: 1,
      exceltdata: [],
      selectcope: {},
      proloading: true,
      progress: 0,
      point: ".",
      time1: null,
      apidata: {},
      isApi: false,
      largevisible: false,
      dialogdata: [],
      sortselect: 0,
      localsortlist: [
        { name: "头底组件替换", id: 0 },
        { name: "标签组件替换", id: 1 },
      ],
      headold: {},
      payvisible: false,
      sharelink: '',
      showshare: false,
      rolelevel: -1,
      watertime: null,
      pwd: '',
    };
  },
  watch: {
    requestList(n) {
      if (n && n.length && this.upindex == 1) {
        this.upCompdata();
      }
    },
    getdataList(n) {
      if (n && n.length && this.getindex == 0 && this.curindex == 1) {
        this.getCompdata();
      }
    },
  },
  computed: {
    showmask() {
      return (
        this.topEditS ||
        this.topEditScope ||
        this.editScope ||
        this.topComp ||
        this.LblComp ||
        this.showdataEdit
      );
    },
  },
  methods: {
    ...method,
    getProdel() {
      const route = this.$route.path
      let gettb = getTbById
      let getlbl = getLblById
      let gettem = getTempdel
      if (route == '/share') {
        gettb = getTbByIdSh
        getlbl = getLblByIdSh
        gettem = getTempdelSh
      }
      this.tempdata = this.temdata
      if (this.tempdata.config_json) {
        let configjson = JSON.parse(this.tempdata.config_json)
        this.scopename = configjson
        this.toptitle = this.tempdata.title || this.tempdata.name
        this.scopename.forEach((item, i) => {
          if (item.issave && item.saveid) {
            const zjParams = {
              id: item.saveid
            }
            getZjData(zjParams).then(del => {
              if (del.status == 200) {
                this.scopename[i] = JSON.parse(del.data.component_config)
                this.scopename = [...this.scopename]
              } else {
                this.$message('该收藏组件已被移除')
              }
            })
          }
          if (this.scopetitlelist[i]) {
            this.scopetitlelist[i].title = item.name
          }
        })
        if (this.tempdata.component_tb) {
          const vdata = {
            id: this.tempdata.component_tb
          }
          gettb(vdata).then(resp => {
            if (resp.status == 200) {
              this.topactive = resp.data.local_id
            }
          })
        }
        if (this.tempdata.component_lbl) {
          const vdata = {
            id: this.tempdata.component_lbl
          }
          getlbl(vdata).then(resp => {
            if (resp.status == 200) {
              this.scopeactive = resp.data.local_id
            }
          })
        }
        this.scopename = [...this.scopename]
      } else {
        let tparams = {
          id: this.tempdata.template_id
        }
        gettem(tparams).then(res => {
          this.tempdata.config_json = res.data.config_json
          let configjson = JSON.parse(this.tempdata.config_json)
          this.tempdata.component_tb = res.data.component_tb
          this.tempdata.component_lbl = res.data.component_lbl
          this.toptitle = this.tempdata.title || this.tempdata.name
          this.scopename = configjson
          if (!this.scopename[7]) {
            this.scopename.push({ compid: '', title: '', vdata: '' })
          }
          this.scopename.forEach((item, i) => {
            if (this.scopetitlelist[i]) {
              this.scopetitlelist[i].title = item.name
            }
          })
          if (this.tempdata.component_tb) {
            const vdata = {
              id: this.tempdata.component_tb
            }
            gettb(vdata).then(resp => {
              if (resp.status == 200) {
                this.topactive = resp.data.local_id
              }
            })
          }
          if (this.tempdata.component_lbl) {
            const vdata = {
              id: this.tempdata.component_lbl
            }
            getlbl(vdata).then(resp => {
              if (resp.status == 200) {
                this.scopeactive = resp.data.local_id
              }
            })
          }
          this.scopename = [...this.scopename]
        })
      }
    },
    openTitle() {
      // 头底组件替换和标签组件替换整合
      let old = JSON.stringify(this.scopeactive);
      this.oldscope = JSON.parse(old);
      let headold = JSON.stringify(this.topactive);
      this.headold = JSON.parse(headold);
      this.levelactive = 0;
      this.LblComp = true;
      this.getZujian();
    },
  },
  mounted() {
    var projectId = this.$route.query.projectId;
    var preview = this.$route.query.preview;
    if (projectId) {
      this.proid = projectId;
      this.getProdel();
    }
    if (preview) {
      this.isPreview = preview;
    } else {
      this.selectinit();
    }
    this.loadAllcomponents();
  },
  async created() {
    const resourceList = [
      require("@/assets/temimg2/bg.jpg"),
      require("@/assets/temimg2/bottom.png"),
      require("@/assets/temimg2/header.png"),
      require("@/assets/temimg2/title.png"),
    ];
    if (!this.time1) {
      this.time1 = setInterval(() => {
        this.addpoint();
      }, 600);
    }
    this.addpoint();
    await preloadResources(resourceList, this.progressCallback);
    clearInterval(this.time1);
    this.time1 = null;
    setTimeout(() => {
      this.proloading = false;
    }, 200);
  },
};
</script>

<style scoped lang="scss">
.tem-box {
  width: 100%;
  height: 100%;
}

.scale-wrap {
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  background: #131313;
  font-family: "Hei";
  position: relative;
}

.back-mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.3;
  z-index: 501;
}

.editFrame {
  width: 100%;
  height: 100%;
  position: relative;
}

.componentS {
  position: absolute;
  width: 1280px;
  /* height: 60vh; */
  background: #181a1b;
  border: 1px solid #3a3b3c;
  top: 20vh;
  left: 50%;
  transform: translateX(-50%);
  transition: all 1s ease;
  z-index: 502;

  &.title {
    width: 715px;

    .r_input {
      width: 645px;

      .el-input__inner {
        font-size: 16px;
        background: #212226;
        border-radius: 4px;
        border: 1px solid #3a3b3c;
      }
    }
  }
}

.componentS .componentTitle {
  width: calc(100% - 2px);
  height: 45px;
  background: #121212;
  display: flex;
  justify-content: space-between;
  font-family: "Hei";
  line-height: 45px;
}

.componentS .componentTitleName {
  font-size: 14px;
  color: #c0c0c0;
  margin-left: 30px;
}

.componentS .componentclose {
  width: 17px;
  margin-right: 30px;
  cursor: pointer;
}

.editMenu {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: rgba(24, 26, 27, 0.4);
  backdrop-filter: blur(5px);
  border-top: 1px solid #484848;
  z-index: 400;
  display: flex;
  line-height: 60px;
  transition: all 1s ease;
}

.editMenu .return {
  width: 12px;
  margin-left: 1.2vw;
  transition: all 1s ease;
}

.editMenu .return button {
  background: transparent;
  border: none;
}

.MenuReturn {
  width: 3% !important;
  opacity: 0.5;
  border: none;
  height: 60px;

  transition: all 1s ease;
}

.menulist {
  display: flex;
  width: 100%;
  transition: all 1s ease;
  opacity: 1;
}

.menuline1 {
  width: 1px;
  height: 30px;
  background: #313131;
  margin: 15px 0 0 1.5%;
}

.menuline2 {
  width: 1px;
  height: 30px;
  background: #313131;
  margin: 15px 0 0 2%;
}

.menulogo {
  width: 84px;
  margin: -1px 0 0 1.5%;
}

.menuname {
  color: #cbcbcb;
  font-size: 16px;
  margin: 0 0 0 1.5%;
}

.menuediticon {
  width: 17px;
  margin: 0 0 0 0.5%;
  background: transparent;
  border: none;
}

.menuversion {
  font-size: 13px;
  color: #cbcbcb;
  border: 1px solid #313131;
  height: 20px;
  line-height: 20px;
  letter-spacing: -1px;
  padding: 0 7px;
  margin: 20px 0 0 1.5%;
}

.menu-pay {
  margin-left: 8px;
  color: #2584ff;
  cursor: pointer;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
}

.modelediticon {
  width: 15px;
  margin: -1px 0 0 28%;
}

.iconname {
  color: #cbcbcb;
  font-size: 15px;
  margin: -1px 0 0 8px;
  font-weight: 550;
  background: transparent;
  border: none;
}

.modelicon2 {
  width: 15px;
  margin: -1px 0 0 2%;
}

.modelicon3 {
  width: 15px;
  margin: -2px 0 0 1.5%;
}

.component {
  position: absolute;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  z-index: 402;
  transition: all 0.5s linear;
  border: 1px dashed #3783f4;
  box-shadow: 0 0 10px rgba(41, 81, 202, 0.8), 0 0 10px rgba(41, 81, 202, 0.8),
    0 0 10px rgba(41, 81, 202, 0.8);

  &.component1 {
    width: calc(100% - 2px);
  }
}

.loading-content {
  width: 100%;
  height: 100%;
  display: block;
  text-align: center;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #d9dde3;

  .loading-line {
    background: #4e5f80;
    border-radius: 4px;
    opacity: 0.9;
    width: 322px;
    height: 10px;
    margin: 100px auto 24px;

    .loading-active {
      height: 100%;
      border-radius: 4px;
      transition: all 0.5s linear;
    }
  }
}

.component .componentFrame {
  width: 100%;
  display: flex;
  justify-content: center;
  column-gap: 54px;
  /* margin: 22% 0 0 5%; */
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.component .componentMenu {
  width: 31%;
  max-width: 180px;
  height: 45px;
  background: #34383d;
  border-radius: 25px;
  text-align: center;
  line-height: 45px;
  transition: all 1s ease;
  font-size: 14px;
  display: flex;
  justify-content: center;
  border: none;
  color: #fff;
  font-family: "Hei";
  cursor: pointer;
}

.component .componentMenu:hover {
  background: #3da6ff;
}

.component .componentIcon {
  width: 15px;
  margin: -1px 8px 0 0;
}

.edit-head {
  height: 134px;
  position: relative;
  pointer-events: auto;

  &:hover {
    .component {
      opacity: 1;
      z-index: 402;
    }
  }
}

.scope-title {
  position: relative;

  .component {
    .componentMenu {
      height: 32px;
      line-height: 32px;
    }

    .componentIcon {
      line-height: 32px;
    }
  }

  &:hover {
    .component {
      opacity: 1;
      z-index: 402;
    }
  }
}

.scope-content,
.center-scope {
  pointer-events: auto;
  position: relative;

  &:hover {
    .component {
      opacity: 1;
      z-index: 402;
    }
  }
}

.edit-content {
  height: 890px;
  width: 100%;
  display: flex;
  pointer-events: none;
}

.edit-left,
.edit-right {
  width: 435px;
  position: relative;
  z-index: 401;
  pointer-events: auto;
}

.edit-left {
  padding: 0 0 0 40px;
}

.edit-right {
  width: 475px;
  padding: 0 40px 0 0;
  box-sizing: border-box;
}

.edit-center {
  width: 914px;
  position: relative;
  z-index: 400;
  height: fit-content;
  padding: 0 24px;
}

.componentClassAll {
  padding: 22px 0 22px 92px;
  display: flex;
  align-items: center;
  column-gap: 56px;
  border-bottom: 1px solid #3a3a3a;
}

.componentClassMenu {
  color: #818181;
  font-size: 14px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s linear;

  &.active {
    font-size: 14px;
    color: #fff;
    font-family: "Hei";

    &::after {
      content: "";
      position: absolute;
      width: 0;
      height: 2px;
      background: #0089ff;
      bottom: -22.5px;
      left: 0;
      animation: zeroto 0.3s linear;
      animation-fill-mode: forwards;
    }
  }
}

@keyframes zeroto {
  from {
    width: 0px;
    left: 50%;
  }

  to {
    width: 100%;
    left: 0;
  }
}

.luckysheet-contain {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 15%;
  width: 1010px;
  height: 670px;
  z-index: 1000;
  background-color: #fff;

  .luckysheet-wrap {
    margin: 0px;
    padding: 0px;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
  }
}

.componentListAll {
  width: calc(100% - 75px);
  margin: 25px 0 0 75px;
  display: flex;
  flex-wrap: wrap;
  height: 466px;
  column-gap: 24px;
  row-gap: 24px;
}

.componentList {
  width: 263px;
  animation: list 1s linear 1;
  animation-fill-mode: forwards;
  opacity: 0;
  cursor: pointer;
  height: fit-content;
  border: 1px solid transparent;
  transition: all 0.3s linear;
  &.active {
    border: 1px solid #3783f4;
    box-shadow: 0 0 15px #1963ea;
    border-radius: 5px;
  }
}

.componentList:hover {
  border: 1px solid #3783f4;
  box-shadow: 0 0 15px #1963ea;
  border-radius: 5px;
}

@keyframes list {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.componentPic {
  width: 100%;
  height: 148px;
  background: #1f1e1f;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.componentPic img {
  width: 100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 100%;
  object-fit: contain;
}

.componentPicName {
  width: 100%;
  height: 40px;
  background: #2d2d33;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  line-height: 40px;
  color: #fff;
  font-size: 12px;
  text-indent: 1em;
  letter-spacing: 1px;
  font-family: "Hei";
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.box-bg {
  position: relative;
  background: url("@/assets/temimg2/bg.jpg") no-repeat;
  background-size: 100% 100%;
  z-index: 400;
  height: 100%;
}

.per-content {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;

  .per-text {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #d9dde3;
    margin-top: 16px;
  }

  .per-line {
    background: #4e5f80;
    border-radius: 5px;
    opacity: 0.9;
    width: 132px;
    position: relative;
    height: 10px;

    .active-line {
      background: #00ff4e;
      transition: all 0.5s linear;
      height: 100%;
      border-radius: 5px;
    }
  }
}

.nodata {
  width: calc(100% - 75px);
  display: flex;
}

.nodata-img {
  width: 185px;
  height: 240px;
  margin: 60px auto 0;
}

// 保存组件css
.save-video {
  display: flex;
  align-items: center;
  position: absolute;
  bottom: -64px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #d9dde3;
}

// 保存组件end</style>
